import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {CodeSearchFirebaseService} from '../../services/code-search-firebase.service';
import {CodeSearchStoreService} from '../../services/code-search-store.service';

interface ISnapshotJSON {
  state: 'finished' | 'processing';
  batch: string;
  total: string;
}

@Component({
  selector: 'app-code-search-loading',
  templateUrl: './code-search-loading.component.html',
  styleUrls: ['./code-search-loading.component.scss']
})
export class CodeSearchLoadingComponent implements OnInit {
  public batch: string | null = null;
  public progress: string | null = null;
  private loadingData: any;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly firebase: CodeSearchFirebaseService,
    private readonly codeSearchStoreService: CodeSearchStoreService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  public ngOnInit() {
    this.loadingData = Object.assign({}, this.route.snapshot.queryParams);
    const rmId = this.route.snapshot.queryParams['refModel'];
    const type = this.route.snapshot.queryParams['type'];

    this.codeSearchStoreService.storeFirebaseLoadingKey(rmId, type);

    this.firebase.subscribeToCodeSearchLoadFirestore((snapshot: any) => {
      const snapshotJSON: ISnapshotJSON = snapshot;

      if (!snapshotJSON) return;

      if (snapshotJSON.batch) {
        this.batch = snapshotJSON.batch;
      }

      if (snapshotJSON.total) {
        this.progress = `${snapshotJSON.total}`;
      } else if (snapshotJSON.state !== 'finished') {
        this.progress = 'no results in batch';
      }

      if (snapshotJSON.state === 'finished') {
        this.finishLoading();
      }

      this.changeDetectorRef.detectChanges();
    });
  }

  private finishLoading(): void {
    this.firebase.unsubscribeFromCodeSearchLoadFirestore();
    // this.firebase.emptyCodeSearchState().then(() => {
    this.router.navigate(['code-search', this.loadingData.refModel], {
      queryParams: {
        rmn: this.loadingData.refModelNode,
        type: this.loadingData.type,
        search: this.loadingData.search,
        reload: true
      }
    });
    // });
  }
}
